module.exports = __webpack_public_path__ + "static/media/new_logo_2.1a53d4b1.png";